import { render } from "ink";
import React from "react";

import App from "./app";
import cliOpts from "./cli";

export interface RunOptions {
	pattern?: string[] | string;
}

const run = (opts?: RunOptions): void => {
	render(<App {...opts} {...cliOpts} />);
};

export default run;
module.exports = run;

export * from "./result";
export * from "./job";
export type { Config } from "./config";
